/**
 * Frees the memory behind a blob address once nothing draws it any more. Only web mints these, so
 * any other address, and any runtime without the browser API, is left alone.
 */
export function revokeBlobUri(uri: string | null | undefined): void {
  if (uri?.startsWith('blob:') && typeof URL.revokeObjectURL === 'function') {
    URL.revokeObjectURL(uri);
  }
}
